import { SetEditActivityIdAction } from './typings'

export const setEditActivityIdActionCreator = (
  payload: number | undefined,
): SetEditActivityIdAction => ({
  type: 'activitySummary/setEditActivityId',
  payload,
})
